import { useCallback, useEffect, useRef } from 'react'
import { BlockerFunction, useBlocker } from 'react-router-dom'
import { ConfirmationModal } from '~/components/ConfirmationModal'
import { useGlobalModal } from '~/components/layout/GlobalModal'

export const useConfirmNavigation = (shouldBlock: boolean): void => {
  // Refs
  const proceedRef = useRef<(() => void) | null>(null)
  const resetRef = useRef<(() => void) | null>(null)

  // Hooks
  const modal = useGlobalModal()

  const blocker: BlockerFunction = useCallback(
    ({ currentLocation, nextLocation }) => {
      if (shouldBlock && currentLocation.pathname !== nextLocation.pathname) {
        modal.open(ConfirmationModal, {
          title: 'Confirm navigation',
          message: 'You have unsaved changes. Are you sure you want to leave this page?',
          trackingLabel: 'common-confirm-navigation',
          onCancel: () => {
            modal.close()
            resetRef.current?.()
          },
          onConfirm: () => {
            modal.close()
            proceedRef.current?.()
          },
        })
        return true
      }
      return false
    },
    [shouldBlock, modal]
  )

  const { proceed, reset } = useBlocker(blocker)

  // Store proceed/reset in refs so they're accessible inside the callback
  useEffect(() => {
    proceedRef.current = proceed || null
    resetRef.current = reset || null
  })
}
